import { CURRENCIES, createCurrencyFormatter } from '../../utils/currency';
import { language } from '../../utils/language';

const CURRENCIES_LIST = {};

$(() => {
  const initializeCurrenciesSelect = () => {
    const euroSelect = $('#euro-select');
    const randSelect = $('#rand-select');
    const euroInput = $('#max_price');
    const randInput = $('#max_price_rand');
    const currenciesElements = $('.currencies');
    const millionsCharacter = $('input#_millions_char').val();

    const getSeparator = () => {
      const numberWithGroupSeparator = 100000;
      return Intl.NumberFormat(language)
        .formatToParts(numberWithGroupSeparator)
        .find((part) => part.type === 'group')?.value;
    };
    const separator = getSeparator();

    const formatTensOfMillions = (currency, price) => {
      const currencySign = CURRENCIES[currency] || '';
      return `${currencySign}${price.slice(0, -6)} ${millionsCharacter}`;
    };

    const formatMillions = (currency, price) => {
      const currencySign = CURRENCIES[currency] || '';
      let formattedPrice = price.slice(0, -5).split('').reverse();
      if (separator === '.') {
        formattedPrice.splice(1, 0, ',');
      } else {
        formattedPrice.splice(1, 0, '.');
      }
      return `${currencySign}${formattedPrice
        .reverse()
        .join('')} ${millionsCharacter}`;
    };
    const formatThousands = (currency) =>
      createCurrencyFormatter({ currency, language });

    const formatRest = (currency, price) => {
      const currencySign = CURRENCIES[currency] || '';
      if (price.includes(currencySign)) {
        return price;
      } else {
        return `${currencySign}${price}`;
      }
    };

    const formatPrice = (select) => {
      const prices = $(select).find('.select-field__dropdown-item');
      prices.each((_, price) => {
        const priceValue = price.dataset.optionValue;
        if (priceValue >= 5000000) {
          price.textContent = formatTensOfMillions(currencies[0], priceValue);
        } else if (priceValue >= 1000000 && priceValue < 5000000) {
          price.textContent = formatMillions(currencies[0], priceValue);
        } else if (priceValue > 0) {
          price.textContent = formatThousands(currencies[0])(priceValue);
        } else {
          price.textContent = formatRest(currencies[0], price.textContent);
        }
      });
    };

    for (let currencyElement of currenciesElements) {
      const name = currencyElement.name;
      const currency = currencyElement.value;
      CURRENCIES_LIST[name] = currency;
    }

    let currencies = [];

    const setCurrenciesForSelectedCountries = (selectedCountries) => {
      selectedCountries = selectedCountries.filter(Boolean);
      currencies = [
        ...new Set(
          selectedCountries.map((country) => CURRENCIES_LIST[country])
        ),
      ];
    };

    const setSelectBox = () => {
      if (currencies.length === 0) {
        euroSelect.show().addClass('disabled');
        randSelect.hide().addClass('disabled');
        euroInput.prop('disabled', 'disabled');
        randInput.prop('disabled', 'disabled');
      } else if (currencies.length > 1) {
        euroSelect.show().addClass('disabled');
        randSelect.hide().addClass('disabled');
        euroInput.prop('disabled', 'disabled');
        randInput.prop('disabled', 'disabled');
      } else if (currencies.includes('ZAR')) {
        formatPrice(randSelect);
        euroSelect.hide().addClass('disabled');
        randSelect.show().removeClass('disabled');
        euroInput.prop('disabled', 'disabled');
        randInput.prop('disabled', false);
      } else {
        formatPrice(euroSelect);
        euroSelect.show().removeClass('disabled');
        randSelect.hide().addClass('disabled');
        euroInput.prop('disabled', false);
        randInput.prop('disabled', 'disabled');
      }
    };

    $('body').on('selectedCountriesChanged', ({ detail }) => {
      const { selectedCountries } = detail;
      setCurrenciesForSelectedCountries(selectedCountries);
      setSelectBox();
    });
    const selectedOptions = $('input#country-select').attr(
      'data-selected-options'
    );
    if (selectedOptions) {
      const selectedCountries = selectedOptions.split(',');
      setCurrenciesForSelectedCountries(selectedCountries);
    }
    setSelectBox();
  };

  initializeCurrenciesSelect();
});
